<template>
  <div>
    <v-form>
      <v-container fluid grid-list-lg>
        <v-layout column warp mx-5>
          <v-flex xs12 id="information">
            <v-layout row wrap>
              <v-row class="mt-5">
                <information-provider-type-detail :providerTypeId="$route.params.id" />
              </v-row>
            </v-layout>
          </v-flex>

          <v-flex xs12 id="subtype">
            <v-card-title>
              <span class="mt-10">Subtype</span>
            </v-card-title>
            <v-row>
              <v-col>
                <v-text-field
                  @input="debounceInput"
                  :value="filter.search"
                  clearable
                  prepend-icon="search"
                  label="Search"
                  single-line
                  hide-details
                />
              </v-col>
              <v-col md="4" align="end" align-self="end">
                <v-btn slot="activator" color="accent" @click="toggleModal(item)"> Add New subtype </v-btn>
              </v-col>
            </v-row>

            <v-row class="mt-5">
              <v-data-table
                :headers="headers"
                :options.sync="pagination"
                :server-items-length="totalProviderSubtypes"
                :items="providerSubtypes"
                item-key="id"
                class="full-width full-height"
                hide-default-footer
              >
                <v-progress-linear v-slot:progress color="blue" indeterminate />
                <template v-if="providerSubtypes.length" v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.id" :style="{ cursor: 'pointer' }">
                      <td class="text-center">{{ item.id }}</td>
                      <td class="text-center">{{ item.name_th }}</td>
                      <td class="text-center">{{ item.name_en }}</td>
                      <td class="text-center">{{ item.description_th }}</td>
                      <td class="text-center">{{ item.description_en }}</td>
                      <td class="px-0 py-1">
                        <v-flex align-center justify-center layout text-center>
                          <v-menu open-on-hover auto offset-y>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" color="secondary"> Action </v-btn>
                            </template>
                            <v-list>
                              <v-list-item @click="editProviderSubtype(item)">
                                <v-list-item-title>EDIT</v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="deleteProviderSubtype(item)">
                                <v-list-item-title>DELETE</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-flex>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-row>

            <v-row class="mt-10 mb-10" align="center">
              <div class="d-flex align-center">
                <v-pagination
                  class="navigation_pagination ml-5"
                  v-model="pagination.page"
                  :length="totalProviderSubtypesPages"
                  :total-visible="5"
                ></v-pagination>
              </div>
            </v-row>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
/*eslint-disable no-unused-vars*/
import { Vue } from 'vue-property-decorator';
import { debounce } from 'lodash';
import InformationProviderTypeDetail from '../../../components/InformationProviderTypeDetail.vue';
import tableMixin from '../../../Mixins/table';
import providerTypes from '../../../services/providerTypes';
import _ from 'lodash';

export default Vue.extend({
  mixins: [tableMixin],
  data: () => ({
    loading: false,
    providerSubtypes: [],
    pagination: {},
    totalProviderSubtypesPages: 0,
    totalProviderSubtypes: 0,
    providerTypeId: 0,
    filter: {
      status: [],
      search: null,
    },
    headers: [
      {
        text: 'Id',
        align: 'center',
        value: 'id',
        sortable: false,
      },
      {
        text: 'Name (TH)',
        align: 'center',
        value: 'name_th',
        sortable: false,
      },
      {
        text: 'Name (EN)',
        align: 'center',
        value: 'name_en',
        sortable: false,
      },
      {
        text: 'Description (TH)',
        align: 'center',
        value: 'description_th',
        sortable: false,
      },
      {
        text: 'Description (EN)',
        align: 'center',
        value: 'description_en',
        sortable: false,
      },
      {
        text: 'Action',
        align: 'center',
        value: 'action',
        sortable: false,
      },
    ],
  }),
  watch: {
    filter: {
      handler() {
        this.getProviderSubtype().then((data) => {
          this.providerSubtypes = data.items;
          this.totalProviderSubtypes = data.total;
          this.totalProviderSubtypesPages = data.totalPages;
        });
      },
      deep: true,
    },
    pagination: {
      handler() {
        this.getProviderSubtype().then((data) => {
          this.providerSubtypes = data.items;
          this.totalProviderSubtypes = data.total;
          this.totalProviderSubtypesPages = data.totalPages;
        });
      },
      deep: true,
    },
  },
  components: {
    InformationProviderTypeDetail,
  },
  methods: {
    editProviderSubtype(item) {
      console.log('editProviderSubtype', item);
    },
    deleteProviderSubtype(item) {
      console.log('deleteProviderSubtype', item);
    },
    getProviderSubtype() {
      this.loading = true;

      return new Promise((resolve, reject) => {
        const { page } = this.pagination;

        let query = {};

        if (_.isUndefined(page)) {
          query.page = 1;
        } else {
          query.page = page;
        }

        query.provider_type_id = this.$route.params.id;
        query.per_page = 5;
        query.no_cache = true;

        if (this.search) query.q = this.search;
        if (this.filter.search) query.q = this.filter.search;

        providerTypes
          .getSubtype(query)
          .then((res) => {
            this.loading = false;
            const items = res.data;
            const meta = res.meta;
            const total = meta.pagination.total;
            const totalPages = meta.pagination.last_page;

            resolve({
              items,
              total,
              totalPages,
            });
          })
          .catch((err) => {
            this.loading = false;
            reject(err);
          });
      });
    },
    debounceInput: debounce(function (e) {
      this.filter.search = e;
    }, 500),
  },
  mounted() {
    this.getProviderSubtype().then((data) => {
      this.providerSubtypes = data.items;
      this.totalProviderSubtypes = data.total;
      this.totalProviderSubtypesPages = data.totalPages;
    });
  },
});
</script>
